import { ArrowRightIcon } from '@fiverr-private/icons';

export default ArrowRightIcon;
